export default __webpack_public_path__ + "static/media/cuisine (2).55145b16.jpg";